{{#each this.columns}}
	<td>
		{{#if url}}
			<a href="{{url}}">{{lookup @root field}}</a>
		{{else}}
			{{lookup @root field}}
		{{/if}}
	</td>
{{/each}}
